
import { Component, Vue } from 'vue-property-decorator'
import CompanyList from '@/components/company/CompanyList.vue'
import authModule from '@/store/auth'

@Component({
  name: 'companies',
  components: { CompanyList }
})
class Companies extends Vue {
  private created(): void {
    if (!(authModule.isSuperadmin || authModule.isAdmin)) {
      this.$router.replace({ name: 'Home' })
    }
  }
}

export default Companies
